<template>
  <cube-page title="部门分析"
             @back="back">
    <div slot="content">
      <!--      <button @click="exportLayout">获取布局</button>-->

      <div v-if="ddiDate && monthDate"
           class="date">
        <span class="text">销售发出:{{ ddiDate.format("YYYY.MM.DD") }}</span>
        <span class="text">商业流向:{{ ddiDate.format("YYYY.MM.DD") }}</span>
        <span class="text">连锁流向:{{ monthDate.format("YYYY.MM.DD") }}</span>
      </div>
      <div class="filter-bar flex-wrap flex-none">
        <cube-select class="area-select"
                     v-model="dept"
                     :options="departmentOptions"
                     placeholder="请选择部门"
                     ref="departmentPicker"
                     @change="changeHandle">
        </cube-select>
      </div>
      <wmq-layout class="layout"
                  style="margin:10px"
                  ref="mainDashboard"
                  :rootLayoutConfig="configData"
                  @load-data="onRequest">
      </wmq-layout>
      <el-tabs v-model="currentBrand"
               @tab-click="handleBrandClick"
               style="margin: 15px"
               :stretch="true">
        <el-tab-pane v-for="item in brandList"
                     :label="item.name"
                     :name="item.name"
                     :key="item.name">
          <wmq-layout v-if="currentBrand === item.name"
                      class="layout"
                      style="margin:10px"
                      :ref="item.name"
                      :rootLayoutConfig="brandConfig[item.name]">
          </wmq-layout>
        </el-tab-pane>
      </el-tabs>
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/department-analyse-ui-config'
import longmu60UiConfig from '@/config/ui-config/department-analyse-ui-config-longmu-60'
import longmu30UiConfig from '@/config/ui-config/department-analyse-ui-config-longmu-30'
import otherBrandUiConfig from '@/config/ui-config/department-analyse-ui-config-other-brand'
import { biData } from '@/api/cube'
import DateUtils from '@/utils/date'
import { getXhDepartmentAnalyse } from '@/api/common'
import { CubeDataHandle } from 'wmq-component'
import { getFlowTime } from '@/api/bigCustomer'
import { get, has, isEmpty, set } from 'lodash'
import CubePage from '../../components/cube-page'
import apiCacheHandle from '@/utils/apiCache'
import moment from 'moment'
export default {
  name: 'DepartmentAnalyse',
  components: { CubePage },
  data () {
    return {
      dept: '',
      ddiDate: undefined,
      monthDate: undefined,
      lastDdiYearMonthArr: undefined,
      ddiMonthArr: undefined,
      lastYearDate: undefined,
      rollbackSixMonthArr: undefined,
      channelTypeQuery: ['龙牡60总部', '龙牡60门店'],
      departmentList: [],
      isClearCache: false,
      currentBrand: undefined,
      brandList: [
        {
          name: '60袋龙牡'
        },
        {
          name: '30袋龙牡'
        },
        {
          name: '108粒便通'
        },
        {
          name: '48粒便通'
        },
        {
          name: '24粒便通'
        },
        {
          name: '45片咽喉片'
        },
        {
          name: '24片咽喉片'
        },
        {
          name: '16片咽喉片'
        }
      ],
      longmu60UiConfig,
      longmu30UiConfig,
      otherBrandUiConfig
    }
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        const dataCodes = data.dataCode
        reqObj.dept = that.dept
        if (dataCodes instanceof Array) {
          const apiArr = []
          const monthList = ['龙牡60标题', '龙牡60总部覆盖', '龙牡60门店覆盖', '协议连锁标题', '协议连锁覆盖', '协议连锁门店覆盖', '非协议连锁标题',
            '非协议连锁覆盖', '单体药店标题', '单体药店覆盖']
          const ddiList = ['黄金单品标题', '销售公司标题', '铺货', '达标', '龙牡60门店铺货标题', '单体药店铺货标题', '协议连锁门店铺货标题', '龙牡60门店达标标题', '单体药店达标标题', '协议连锁门店达标标题']
          dataCodes.forEach(code => {
            const orgReq = get(reqObj, code, {})
            const req = that.handleCodeQuery(code, orgReq)
            if (ddiList.indexOf(code) > -1) {
              apiArr.push(new Promise(resolve => {
                resolve({ data: { subTitle: that.ddiDate.format('YYYY') + '-01-01' + '至' + that.ddiDate.format('YYYY-MM-DD') } })
              }))
            } else if (monthList.indexOf(code) > -1) {
              apiArr.push(new Promise(resolve => {
                resolve({ data: { subTitle: that.rollbackSixMonthArr[5] + '-01' + '至' + that.monthDate.format('YYYY-MM-DD') } })
              }))
            } else if (code === '健民发出标题') {
              apiArr.push(new Promise(resolve => {
                resolve({ data: { subTitle: that.ddiDate.format('YYYY-MM') + '-01' + '至' + that.ddiDate.format('YYYY-MM-DD') } })
              }))
            } else {
              apiArr.push(apiCacheHandle(biData, that.pageKey, (argArray) => { return 'bidata.' + argArray[0] + '.' + JSON.stringify(req) }, true, that)(code, req))
            }
          })
          return Promise.all(apiArr).then((res) => {
            const result = {}
            for (let i = 0; i < res.length; i++) {
              result[dataCodes[i]] = CubeDataHandle.handleCubeData(res[i].data)
            }
            return new Promise((resolve) => {
              resolve(result)
            })
          })
        } else {
          if (dataCodes === '协议连锁标题' || dataCodes === '龙牡60标题' || dataCodes === '非协议连锁标题' || dataCodes === '单体药店标题') {
            return new Promise((resolve) => {
              resolve({})
            })
          }
          reqObj = that.handleCodeQuery(dataCodes, reqObj)
          data.queryParams = {
            ...data.queryParams,
            ...reqObj
          }
          return apiCacheHandle(biData, that.pageKey, (argArray) => { return 'bidata.' + argArray[0] + '.' + JSON.stringify(reqObj) }, true, that)(dataCodes, reqObj).then((res) => {
            return new Promise((resolve) => {
              resolve(CubeDataHandle.handleCubeData(res.data))
            })
          })
        }
      }
    }
  },
  mounted () {
    Promise.all([apiCacheHandle(getXhDepartmentAnalyse, this.pageKey, () => { return 'getDepartmentAnalyse' }, true, this)(),
      apiCacheHandle(getFlowTime, this.pageKey, () => { return 'flowTime' }, true, this)()])
      .then(([deptRes, flowTimeRes]) => {
        this.departmentList = deptRes.data.detail

        this.ddiDate = moment(flowTimeRes.data.ddiMaxDay || flowTimeRes.data.monthMaxDay)
        this.monthDate = moment(flowTimeRes.data.monthMaxDay)
        this.lastYearDate = moment(flowTimeRes.data.ddiMaxDay || flowTimeRes.data.monthMaxDay).subtract(1, 'years')
        this.lastDdiYearMonthArr = DateUtils.getMonthArr(this.lastYearDate.format('YYYY-MM'), -(this.lastYearDate.get('month') + 1)).map(item => item.format('YYYY-MM'))
        this.rollbackSixMonthArr = DateUtils.getMonthArr(this.monthDate.format('YYYY-MM'), -6).map(item => item.format('YYYY-MM'))
        this.ddiMonthArr = DateUtils.getMonthArr(this.ddiDate.format('YYYY-MM'), -(this.ddiDate.get('month') + 1)).map(item => item.format('YYYY-MM'))
        this.$store.dispatch('GetCacheInfo', { pageKey: this.pageKey, apiKey: 'page' }).then(page => {
          this.currentBrand = get(page, 'currentBrand', '60袋龙牡')
          this.$nextTick(() => {
            this.dept = get(page, 'dept', this.departmentOptions[0].value)
            this.changeHandle(this.dept)
            setTimeout(() => {
              document.getElementsByClassName('content')[0].scrollTop = get(page, 'top', 0)
            }, 100)
          })
        })
      })
    const that = this
    this.$refs.mainDashboard.dataEventBus.$on(
      'mapTabChange',
      function (msg, channelTypeVue) {
        const channelType = channelTypeVue.$options.propsData.label
        let channelTypeQuery
        if (channelType === '龙牡60') {
          channelTypeQuery = ['龙牡60总部', '龙牡60门店']
        } else if (channelType === '协议连锁') {
          channelTypeQuery = ['协议连锁', '协议连锁门店']
        } else if (channelType === '非协议连锁') {
          channelTypeQuery = ['非协议连锁']
        }
        that.channelTypeQuery = channelTypeQuery
        that.$refs.mainDashboard.refreshByKey('终端覆盖')
      }
    )
  },
  beforeRouteLeave (to, from, next) {
    if (['productCoverByDept', 'deptAreaDistribution', 'deptSales'].indexOf(to.name) > -1) {
      this.$store.commit('SET_CACHE_INFO', { pageKey: this.pageKey, apiKey: 'page.dept', data: this.dept })
      this.$store.commit('SET_CACHE_INFO', { pageKey: this.pageKey, apiKey: 'page.top', data: document.getElementsByClassName('content')[0].scrollTop })
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (['productCoverByDept', 'deptAreaDistribution', 'deptSales'].indexOf(from.name) === -1) {
        vm.$store.commit('CLEAR_CACHE_INFO', vm.pageKey)
      }
    })
  },
  computed: {
    brandConfig () {
      const config = {}
      this.brandList.forEach(item => {
        if (item.name === '60袋龙牡') {
          config[item.name] = this.longmu60UiConfig
        } else if (item.name === '30袋龙牡') {
          config[item.name] = this.longmu30UiConfig
        } else {
          config[item.name] = { ...this.otherBrandUiConfig }
        }
      })
      return config
    },
    pageKey () {
      return this.$route.name
    },
    departmentOptions () {
      const departmentOptions = []
      this.departmentList.forEach((item) => {
        departmentOptions.push({
          text: item.departmentName,
          value: item.departmentName
        })
      })
      return departmentOptions
    },
    configData () {
      set(uiConfig, 'schema.0.children.ka产品.props.options.conditions', {
        text: [
          {
            field: 'monthAmount_LINK',
            mapping: this.filedMap
          },
          {
            field: 'yearAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      set(uiConfig, 'schema.0.children.商务产品.props.options.conditions', {
        text: [
          {
            field: 'monthAmount_LINK',
            mapping: this.filedMap
          },
          {
            field: 'yearAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      set(uiConfig, 'schema.0.children.招商产品.props.options.conditions', {
        text: [
          {
            field: 'monthAmount_LINK',
            mapping: this.filedMap
          },
          {
            field: 'yearAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      set(uiConfig, 'schema.0.children.黄金单品表格.props.options.conditions', {
        text: [
          {
            field: 'salesAmount_LINK',
            mapping: this.filedMap
          },
          {
            field: 'yearAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      return uiConfig
    }
  },
  methods: {
    handleCodeQuery (dataCode, reqObj) {
      reqObj.dept = this.dept
      const productCover = ['product60headquartersNumber', 'product60headquartersPercent', 'product60storesNumber', 'product60storesPercent', 'product60headquartersCoverList',
        'product60storesCoverList', 'product30controllableHeadquartersNumber', 'product30controllableHeadquartersPercent', 'product30controllableStoresNumber',
        'product30controllableStoresPercent', 'product30controllableHeadquartersCoverList', 'product30controllableStoresCoverList', 'product30notControllableHeadquartersNumber',
        'product30notControllableHeadquartersPercent', 'product30notControllableHeadquartersCoverList', 'product30storeHeadquartersNumber', 'product30storeHeadquartersPercent',
        'product30storeHeadquartersCoverList', '协议连锁标题', '龙牡60标题', '非协议连锁标题', '单体药店标题']
      const distributionStandards = ['distributionIndicators', 'standardsIndicators',
        'product60storesDistributionIndicatorsPercent', 'product60storesDistributionIndicatorsNum',
        'product30notControllableStoresDistributionIndicatorsNum', 'product30notControllableStoresDistributionIndicatorsPercent',
        'product30controllableStoresDistributionIndicatorsPercent', 'product30controllableStoresDistributionIndicatorsNum',
        'product60storesStandardsIndicatorsPercent', 'product60storesStandardsIndicatorsNum',
        'product30notControllableStoresStandardsIndicatorsPercent', 'product30notControllableStoresStandardsIndicatorsNum',
        'product30controllableStoresStandardsIndicatorsPercent', 'product30controllableStoresStandardsIndicatorsNum']
      if (distributionStandards.indexOf(dataCode) > -1) {
        reqObj.year = this.ddiDate.format('YYYY')
      }
      if (productCover.indexOf(dataCode) > -1) {
        reqObj.month = this.rollbackSixMonthArr
      }
      if (dataCode === 'productList2022') {
        reqObj.date = this.ddiDate.format('YYYY-MM-DD')
      }
      if (dataCode === 'productList2021') {
        reqObj.date = this.lastYearDate.format('YYYY-MM-DD')
      }
      if (dataCode === 'productPercent') {
        reqObj.date = this.ddiDate.format('YYYY-MM-DD')
      }
      if (has(reqObj, 'year') && isEmpty(get(reqObj, 'year'))) {
        reqObj.year = this.ddiDate.format('YYYY')
      }
      // dateFlag === '__date__' 由于has(reqObj, 'date') 为false 导致json里的date 为空 过滤异常 添加一个Flag
      if (get(reqObj, 'date') === '__date__') {
        reqObj.date = this.ddiDate.format('YYYY-MM-DD')
      }
      if (has(reqObj, 'month') && isEmpty(get(reqObj, 'month'))) {
        reqObj.month = this.ddiDate.format('YYYY-MM')
      }
      if (has(reqObj, 'productBrand')) {
        reqObj.productBrand = this.currentBrand
      }
      return reqObj
    },
    back () {
      this.$store.commit('CLEAR_CACHE_INFO', this.pageKey)
    },
    exportLayout () {
      const layoutConfig = this.$refs.mainDashboard.extractLayoutConfig()
      window.prompt('布局信息', JSON.stringify(layoutConfig))
    },
    filedMap (fieldValue) {
      if (fieldValue && fieldValue.indexOf('-') > -1) {
        return {
          fill: 'red'
        }
      }
      return { fill: '#333333' }
    },
    changeHandle () {
      if (this.isClearCache) {
        this.$store.commit('CLEAR_CACHE_INFO_API', { pageKey: this.pageKey, apiKey: 'bidata' })
      }
      this.isClearCache = true
      this.$refs.mainDashboard.refreshAll()
      this.brandRefreshAll()
    },
    handleBrandClick () {
      this.$store.commit('SET_CACHE_INFO', { pageKey: this.pageKey, apiKey: 'page.currentBrand', data: this.currentBrand })
      const scrollTop = document.getElementsByClassName('content')[0].scrollTop
      this.$nextTick(() => {
        this.brandRefreshAll()
        setTimeout(() => {
          document.getElementsByClassName('content')[0].scrollTop = scrollTop
        }, 5)
      })
    },
    brandRefreshAll () {
      this.$refs[this.currentBrand][0].refreshAll()
    }
  }
}
</script>
<style scoped lang="stylus">
.date
  font-size 18px
  color #666666
  padding 30px 30px 0px 30px
  .text
    margin 0px 10px
.area-select
  width 100%
  margin 20px
.vue-grid-layout
  background #fff !important
</style>
<style lang="stylus">
.chart-open-link
  font-size 14PX
  color #5785ea
  padding-left 28px
  font-weight normal
  display flex
.tab
  float right
  height 50px
  margin-top -25px
  .el-tabs__item
    font-size 20px !important
    padding 0px 10px !important
    height 30px
.cube-picker-panel .cube-picker-content .cube-picker-wheel-wrapper >div:only-child
  width 100% !important
.layout .el-progress-bar__innerText
  color #000 !important
</style>
